import { type MarketplacePaginatedRes as PaginatedRes } from '@dvb/common';

import type { Course, CourseNft, GetCourseNftArgs } from './courses.types';

import { authAxios } from '../../client';

export const getCoursesRequest = async (cursor?: string) => {
  const { data } = await authAxios.post<PaginatedRes<Course[]>>(
    '/api/v1/course/list',
    {
      cursor,
    }
  );
  return data;
};

export const getCourseNftRequest = async ({
  courseUuid,
  cursor,
  search,
}: GetCourseNftArgs) => {
  const { data } = await authAxios.post<PaginatedRes<CourseNft[]>>(
    '/api/v1/course/nft',
    {
      course_uuid: courseUuid,
      cursor,
      search,
    }
  );
  return data;
};

export const getNftDetailRequest = async (nftUuid: string) => {
  const { data } = await authAxios.post<CourseNft>(
    '/api/v1/course/nft-details',
    {
      nft_uuid: nftUuid,
    }
  );
  return data;
};
